export default __webpack_public_path__ + "static/media/education.e4224fb4.jpg";